import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Card, Modal } from "react-bootstrap";
import { toDateTimeFR } from "../../../utils/datesHeures";

const BlocEvenementsThumbnail = (props) => {
  const { t } = useTranslation();
  const { evenementObject } = props;
  const [showDetailEvent, setShowDetailEvent] = useState(false);

  const openModal = () => {
    setShowDetailEvent(true);
  };

  const closeModal = () => {
    setShowDetailEvent(false);
  };

  return (
    <>
      <Card className="d-flex flex-column justify-content-between align-items-center   componentEvenementThumbnail m-2">
        <span className="overflowInContent" onClick={openModal}>
          <div className="text-center">
            <Card.Img
              className="vignetteEvenement p-1 m-auto"
              variant="top"
              src={evenementObject.vignette}
            />
          </div>
          <Card.Body>
            <div className="date">
              {/* {t("public.componentEvenement.publieLe")}{" "}
            {toDateTimeFR(evenementObject.date_publication)} */}
              {evenementObject.date_evenement && evenementObject.date_fin_evenement
                ? t("public.componentEvenement.du") +
                  `  ${evenementObject.date_evenement}` +
                  t("public.componentEvenement.au") +
                  `  ${evenementObject.date_fin_evenement}`
                : ""}
            </div>
            <Card.Title className="mt-2">{evenementObject.titre}</Card.Title>
            <div className="titreEspace">{evenementObject.nom}</div>
          </Card.Body>
        </span>
        <Button
          href={
            process.env.REACT_APP_URL_COLIDEE +
            "/o" +
            evenementObject.id_entreprise +
            "p" +
            evenementObject.id_plateforme +
            "/evenements.htm?event=" +
            evenementObject.id_evenement
          }
          target="_blank"
          rel="noreferrer"
          className="buttonCard"
        >
          {t("public.boutons.je_m_inscris")}
        </Button>
      </Card>

      <Modal size="lg" show={showDetailEvent} onHide={closeModal} className="modalDetailEvenement">
        <Modal.Header closeButton>
          <Modal.Title>
            {evenementObject.titre}
            <div className="sousTitreDetail">
              {evenementObject.date_evenement && evenementObject.date_fin_evenement
                ? t("public.componentEvenement.du") +
                  `  ${evenementObject.date_evenement}` +
                  t("public.componentEvenement.au") +
                  `  ${evenementObject.date_fin_evenement}`
                : ""}
              - {t("public.componentEvenement.publieLe")}{" "}
              {toDateTimeFR(evenementObject.date_publication)}{" "}
              {t("public.componentEvenement.publiePar")}{" "}
              <a
                href={process.env.REACT_APP_URL_COLIDEE + "/o" + evenementObject.id_entreprise}
                target="_blank"
                rel="noreferrer"
              >
                {evenementObject.nom_entreprise}
              </a>{" "}
              {t("public.componentEvenement.publieSur")}{" "}
              <a
                href={
                  process.env.REACT_APP_URL_COLIDEE +
                  "/o" +
                  evenementObject.id_entreprise +
                  "p" +
                  evenementObject.id_plateforme
                }
                target="_blank"
                rel="noreferrer"
              >
                {evenementObject.nom}
              </a>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: evenementObject.contenu }} />
          <hr />
          <Button
            href={
              process.env.REACT_APP_URL_COLIDEE +
              "/o" +
              evenementObject.id_entreprise +
              "p" +
              evenementObject.id_plateforme +
              "/evenements.htm?event=" +
              evenementObject.id_evenement
            }
            target="_blank"
            rel="noreferrer"
            className="buttonCard float-end w-25"
          >
            {t("public.boutons.je_m_inscris")}
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BlocEvenementsThumbnail;
